const url = { root: "https://apilegalis.dbcrea.com/", api: "https://apilegalis.dbcrea.com/api/" }
export default url;

